import { useTranslation } from "react-i18next";
import i18nInstance, { SUPPORTED_LANGUAGES } from "@/i18n";
import { Globe, ChevronDown } from "lucide-react";

// Sélecteur de langue réutilisable — <select> NATIF (fiable à 100% sur mobile/tactile iOS/Android).
// État replié : icône globe + CODE court (ex. « FR ») => compact, ne déborde jamais l'en-tête mobile.
// Liste déroulante native : noms complets dans la langue (Français, English, Español…).
// Le <select> transparent est superposé (absolute inset-0) : tout tap ouvre le sélecteur natif.
// variant: "light" (fond sombre) / "dark" (fond clair).
export function LanguageSwitcher({ variant = "dark", className = "" }) {
  const { t, i18n } = useTranslation();
  const inst = i18n || i18nInstance;
  const current2 = (inst.language || "fr").slice(0, 2);
  const currentCode = current2.toUpperCase();

  const change = (code) => {
    const target = SUPPORTED_LANGUAGES.find((l) => l.code === code);
    if (!target || !target.ready) return; // langues non prêtes : verrouillées
    inst.changeLanguage(code);
    try { localStorage.setItem("i18nextLng", code); } catch (e) { /* noop */ }
  };

  const light = variant === "light";
  return (
    <div
      data-testid="lang-switcher"
      className={`relative inline-flex h-11 shrink-0 items-center gap-1.5 rounded-full border pl-2.5 pr-2 transition-colors ${
        light
          ? "border-white/20 bg-white/5 text-white focus-within:border-[#C6A87C]/60 hover:border-[#C6A87C]/60"
          : "border-slate-300 text-[#0F172A] focus-within:border-[#C6A87C] hover:border-[#C6A87C]"
      } ${className}`}
    >
      <Globe className={`h-4 w-4 shrink-0 ${light ? "text-slate-300" : "text-slate-500"}`} />
      <span className="text-sm font-medium leading-none">{currentCode}</span>
      <ChevronDown className={`h-3.5 w-3.5 shrink-0 opacity-60 ${light ? "text-white" : "text-[#0F172A]"}`} />
      <select
        data-testid="lang-select-trigger"
        aria-label={t("common.language")}
        value={current2}
        onChange={(e) => change(e.target.value)}
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
      >
        {SUPPORTED_LANGUAGES.map((l) => (
          <option key={l.code} value={l.code} disabled={!l.ready} data-testid={`lang-${l.code}`} className="text-slate-900">
            {l.label}{!l.ready ? ` — ${t("common.comingSoon", "bientôt disponible")}` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSwitcher;
